import React from 'react';
import shareRide from '../images/shareride.png'
import digilearn from '../images/digilearn.png'
import outscale from '../images/outscale.png'
import tictactoe from '../images/tictactoe.png'
import hungrybirds from '../images/hungrybirds.png'
import storeemart from '../images/storeemart.png'

const Projects = () => {
    return(

        <section className="page-section portfolio" id="projects">
        <div className="bg-primary p-5">
        <div className="container1 mt-2 mb-5">

            <h2 className="page-section-heading text-center text-uppercase text-light mb-0">My Portfolio</h2>

            <div className="divider-custom divider-light">
                <div className="divider-custom-line"></div>
                <div className="divider-custom-icon"><i class="fas fa-star"></i></div>
                <div className="divider-custom-line"></div>
            </div>

            <div className="row text-center">


            <div className="col-lg-6 col-md-12 margin-img">
            <a href="https://shareride.netlify.com/" target="_blank">
            <div className="img-wrapper">
                <img src={shareRide} className="card-img-top inner-img" alt="..."/>
           </div>
            </a>
        </div>

        <div className="col-lg-6 col-md-12 margin-img">
        <a href="https://outscale.netlify.app/" target="_blank">
            <div className="img-wrapper">
                <img src={outscale} className="card-img-top inner-img" alt="..."/>
            </div>
        </a>
        </div>

        <div className="col-lg-6 col-md-12 margin-img">
        <a href="https://hungrybirds.netlify.app/" target="_blank">
            <div className="img-wrapper">
                <img src={hungrybirds} className="card-img-top inner-img" alt="..."/>
            </div>
        </a>
        </div>

        <div className="col-lg-6 col-md-12 margin-img">
        <a href="https://digilearn.netlify.app/" target="_blank">
            <div className="img-wrapper">
                <img src={digilearn} className="card-img-top inner-img" alt="..."/>
            </div>
            </a>
        </div>



        <div className="col-lg-6 col-md-12 margin-img">
        <a href="https://tic-tac-toe-sajid.netlify.app/" target="_blank">
            <div className="img-wrapper">
                <img src={tictactoe} className="card-img-top inner-img" alt="..."/>
            </div>
        </a>
        </div>



        <div className="col-lg-6 col-md-12 margin-img">
        <a href="https://store-e-mart.netlify.app/" target="_blank">
            <div className="img-wrapper">
                <img src={storeemart} className="card-img-top inner-img" alt="..."/>
            </div>
        </a>
        </div>

            </div>
            <div className="text-center mt-5">
                    <a className="btn btn-xl btn-outline-light" href="https://github.com/sajidlpu1" target="_blank">
                    <i className="fab fa-github f-size"></i> See More
                    </a>
                </div>
        </div>
        </div>
    </section>

    );
}

export default Projects;